import {
   createUniqueId,
   dateTimeFormat,
   getHostCarrierCode,
} from '../../../utils/common-util';
import {
   USER_ACTION_CODE_FARES_SCREEN,
   DISTRIBUTION_STATUS,
   DISTRIBUTION_ACTIONS,
   LAST_UPDATED_SUFFIX,
} from '../../../utils/constants';
import { DateUtil } from '../../../utils/date-util';

export function findSelectedRecordDetails(
   selectedIndex,
   distributionGroupData
) {
   return distributionGroupData[selectedIndex > 1 ? selectedIndex - 1 : 0];
}

export function updateRowDatWithNotes(recordDetails, noteText) {
   recordDetails.uac = USER_ACTION_CODE_FARES_SCREEN.UPDATE;
   recordDetails.distributionGroupLogs.push({
      timeStamp: DateUtil.estTime(new Date()).format(
         DateUtil.DATE_FORMATS
            .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
      ),
      user: recordDetails.user,
      action: DISTRIBUTION_ACTIONS.NOTE,
      notes: noteText,
   });
   return recordDetails;
}

export function updateDistributionGroupLogData(
   distributionGroupData,
   updateRecord
) {
   const findIndex = distributionGroupData.findIndex(
      (record) => record.dgNumber === updateRecord[0]?.dgNumber
   );
   distributionGroupData[findIndex] = updateRecord[0];
   return distributionGroupData;
}
export function dateFormat(value) {
   return value ? dateTimeFormat(value) : '';
}
export function estTimeZoneFormat(value) {
   if (value)
      return DateUtil.estTime(new Date(value)).format(
         DateUtil.DATE_FORMATS
            .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
      );
   else return '';
}
export function insertNewRecord(newRecord, distributionGroupData) {
   newRecord.id = createUniqueId();
   distributionGroupData.unshift(newRecord);
   return [...distributionGroupData];
}

export function insertUniqueId(distributionGroupData) {
   distributionGroupData.forEach((record) => (record.id = createUniqueId()));
   return distributionGroupData;
}
export function filterDistributionGroupNumbers(distributionGroupData) {
   return distributionGroupData.map((record) => record.dgNumber);
}
export function removedSelectedRecord(dgNumbers, distributionGroupData) {
   return distributionGroupData.filter(
      (record) => !dgNumbers.includes(record.dgNumber)
   );
}

export function updateDistributionGroupRecords(oldData, editedRowData) {
   oldData.forEach((oldRecord) => {
      const index = editedRowData.findIndex(
         (record) => record.dgNumber === oldRecord.dgNumber
      );
      oldRecord.id = createUniqueId();
      editedRowData.splice(index, 1, oldRecord);
   });
   return [...editedRowData];
}

export function parseApprovedPayload(distributionGroupData) {
   return distributionGroupData.map((record) => {
      const {
         user,
         dgNumber,
         email,
         exclusiveAccessIndicator,
         intDistributionTimeStamp,
         lowFareCheckIndicator,
         releaseIndicator,
         taxIndicator,
      } = record;
      return {
         user,
         carrierCode: getHostCarrierCode(),
         dgNumber,
         emailId: email,
         exclusiveAccessIndicator,
         intDistributionTimeStamp,
         lowFareCheckIndicator,
         releaseIndicator,
         taxIndicator,
         productType: 'I',
      };
   });
}

export function removeIntDistributionTimeStamp(distributionGroupData) {
   return distributionGroupData.map(
      // eslint-disable-next-line no-unused-vars
      ({ intDistributionTimeStamp, ...record }) => record
   );
}

export function parseSavePayload(distributionGroupData, lastEditFields) {
   distributionGroupData.forEach(
      (record) => (
         (record.intDistributionTimeStamp = estTimeZoneFormat(
            record.intDistributionTimeStamp
         )),
         record.distributionGroupLogs.push({
            timeStamp: DateUtil.estTime(new Date()).format(
               DateUtil.DATE_FORMATS
                  .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
            ),
            user: record.user,
            action: DISTRIBUTION_ACTIONS.UPDATED,
            notes: `${
               lastEditFields.find(
                  (editedRecord) => editedRecord.id === record.id
               )?.editField
            }${LAST_UPDATED_SUFFIX}`,
         })
      )
   );
   return distributionGroupData;
}

export function isEditAllowed(status) {
   return status !== DISTRIBUTION_STATUS.DISTRIBUTED;
}

export function findLastEditedDetails(distributionGroupData, editField) {
   return distributionGroupData.find((record) => record.field === editField)
      .headerTooltip;
}

export const CUSTOM_CONTEXT_MENU_CONFIG = {
   enableInsertNewRowWithData: true,
   insertNewRowWithDataText: 'New Distribution Group',
   enableDelete: true,
   enableCopy: true,
   enableCopyWithHeaders: true,
   enableRemoveSelectedRow: true,
   enableUndo: true,
   enableOpenNewTab: true,
   openNewTabText: 'Show Fares',
   enableSave: true,
   enableDistributeData: true,
   distributeDataText: 'Distribute/Approve',
   enableExportData: true,
   preventDefaultRowDeletion: true,
};

export const CUSTOM_CONTEXT_MENU_CONFIG_FOR_EMPTY_DATASET = {
   enableInsertNewRowWithData: false,
   insertNewRowWithDataText: 'New Distribution Group',
   enableDelete: false,
   enableRemoveSelectedRow: false,
   enableUndo: false,
   enableOpenNewTab: false,
   openNewTabText: 'Show Fares',
   enableDistributeData: false,
   distributeDataText: 'Distribute/Approve',
   enableExportData: false,
   enableSave: false,
   enableCopy: false,
   enableCopyWithHeaders: false,
   preventDefaultRowDeletion: true,
};

export function getContextMenuConfig(rowData) {
   return rowData.length > 0
      ? CUSTOM_CONTEXT_MENU_CONFIG
      : CUSTOM_CONTEXT_MENU_CONFIG_FOR_EMPTY_DATASET;
}

export function generateEditRecordsDetails(
   selectedRecordId,
   editFieldData = [],
   editedFieldName
) {
   if (editFieldData.length > 0) {
      const isAlreadyEditRecord = editFieldData.some(
         (record) => record.id === selectedRecordId
      );
      if (isAlreadyEditRecord) {
         editFieldData.map((record) => {
            if (record.id === selectedRecordId)
               record.editField = record.editField.concat(',', editedFieldName);
            return record;
         });
      } else {
         const editDetails = {
            id: selectedRecordId,
            editField: editedFieldName,
         };
         editFieldData.push(editDetails);
      }
   } else {
      const editDetails = {
         id: selectedRecordId,
         editField: editedFieldName,
      };
      editFieldData.push(editDetails);
   }
   return editFieldData;
}
